module.exports = __webpack_public_path__ + "static/media/Corporate.044a54e8.jpg";